// a function that takes a date in string format and converts it to milliseconds or null (if the date doesn't exist)
function dateToNumber(date) {
    let result;
    if (date !== "") {
        result = new Date(date).getTime();
    } else {
        result = null;
    }
    return result;
}

// a function that gets the value of a text, date, or numeric field
function assignPrimitiveToField(field) {
    let fieldValue;
    if (field.type === 'numeric' && field.numericValue !== undefined && field.numericValue !== null) {
        // ensure every numeric value is a number and not a string
        fieldValue = Number(field.numericValue);
    } else if (field.type === 'text' && field.textValue !== undefined) {
        // return all filled out text values
        // if a text value is an empty string set it to null so that validation passes
        fieldValue = field.textValue !== '' ? field.textValue : null;
    } else if (field.type === 'date' && field.dateValue) {
        // return all filled out data values
        fieldValue = dateToNumber(field.dateValue);
    }
    return fieldValue;
}

/**
 * recursive function used to generate the value of an object request param for QuickQuote.
 * stops at a primitive value and begins to generate the object from the bottom up
 *
 * @param {string} parentObjType denotes the type of the field's parent. should be either array or object
 * @param fields an array of children from the previous field
 * @returns returns the value of a field that is usable by QuickQuote.
 */
function convertNestedObject(parentObjType, fields) {
    // variable to notate whether the field's parent was an object or array. true for object
    const parentIsObject = parentObjType === 'object';
    // variable to store the results of all of a parent's children
    let result;
    // if the parent is an object then result should be an object otherwise result should be an array
    if (parentIsObject) {
        result = {};
    } else {
        result = [];
    }

    // for each field, or child
    for (let field of fields) {
        // variable to store the result
        let fieldResult;
        // if the field has objects
        if (field.objects) {
            // re-call the function using it's type and children as objects and set that as the field result
            fieldResult = convertNestedObject(field.type, field.objects)
        // if the field does not have objects. This would make it primitive
        } else {
            // get the primitive value of the field
            fieldResult = assignPrimitiveToField(field);
        }

        // if the parent is an object then set the result equal to the field's parameter in the object
        if (parentIsObject) {
            result[field.param] = fieldResult;
        // if the parent is an array then just push the field result to the parent's result
        } else {
            result.push(fieldResult);
        }
    }
    // return the result of the field
    return result;
}

/**
 *
 * @param fields array of fields generated by the backend of QDU.
 * @returns the request object that is represented by the fields array.
 */
const convertDefault = (fields) => {
    const body = {};
    for (let field of fields) {
        if (field.textValue === '') {
            // if a field's text value is '' then replace it with a default None
            body[field.param] = 'None';
        } else if (field.objects) {
            // convert a field's objects into an object readable by QuickQuote
            body[field.param] = convertNestedObject(field.type, field.objects)
        } else {
            // get the value from a primitive (date, text, or numeric) field
            body[field.param] = assignPrimitiveToField(field);
        }
    }
    return body;
}

module.exports = {
    convertDefault
}